<template>
  <settings-modal class="card-payment-cancel-modal">
    <template slot="heading">Cancel payment {{ payment.id }}?</template>

    <error-alert :error="error" />

    <p class="subheading red--text text-darken-2 mb-0">Ensure that the hold on this card transaction should be removed before confirming it.</p>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardPaymentCancelModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        isLoading: false,
        error: null,
        cancelPaymentApiRequest: new ApiRequest(PaymentApi.cancelByCardDepartment)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.setError(null)
        this.setIsLoading(true)

        this.cancelPaymentApiRequest
          .execute(this.payment.id)
          .then(this.cancelSuccessHandler)
          .catch((error) => {
            this.setError(error)
            this.setIsLoading(false)
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully canceled.' }
          })
        }, 100)
      },
      setIsLoading (isLoading) {
        return this.$set(this, 'isLoading', isLoading)
      },
      setError (error) {
        return this.$set(this, 'error', error)
      }
    }
  }
</script>

<style lang="scss">
  .card-payment-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
